import { useRouter }           from "next/router";
import { useEffect, useState } from "react";

import { LivePageTags }                                    from "_common/seo";
import { initialValidations }                              from "_common/ssrWrapper";
import { enableBackupAPIsInCookies }                       from "_common/utils";
import { getGameAndTournament, formatOrderedLiveTabsData } from "_common/utils/live";
import NewLivePage                                         from "_components/pages/live";
import {
	getLiveTabOrder
} from "_services/api/broadcast";
import { getSEOTags } from "_services/api/feed";

function Live ( props ) {
	const [ backupResponseData, setBackupResponseData ] = useState ( null );
	const [ isLoading, setIsLoading ]                   = useState ( false );
	const router                                        = useRouter ();
	const seoTags                                       = props?.seoTags;
	const responseData                                  = backupResponseData ? backupResponseData : props?.response;

	const getFallbackData = async function () {
		try {

			setIsLoading ( true );

			const liveTabOrder = await getLiveTabOrder ();

			const { gameCards, tournaments } = formatOrderedLiveTabsData ( liveTabOrder );

			const { response } = await getGameAndTournament ( { defaultProps: null, gameCards, tournaments } );

			setBackupResponseData ( response );

			setIsLoading ( false );

		} catch ( error ) {
			setIsLoading ( false );
		}
	};

	useEffect ( () => {
		if ( props?.response?.length )
			return;

		enableBackupAPIsInCookies ();
		getFallbackData ();
	}, [ router?.query ] );

	if ( isLoading ) return null;

	return (
		<>
			<LivePageTags
				endpoint = { props?.currentPath }
				seoTags  = { seoTags }
			/>

			<NewLivePage
				data     = { responseData }
				isMobile = { props?.isMobile }
			/>

		</>
	);
}

const getServerSideProps = async context => initialValidations ( context, async ( defaultProps, context ) => {
	try {
		let data, seoTags, pageName = "livePage";
		let forceLogout             = false;

		const results = await Promise.allSettled (
			[
				getLiveTabOrder.bind ( defaultProps ) (),
				getSEOTags.bind ( defaultProps ) ( { pageName } )
			]
		);

		results.forEach ( ( result, index ) => {
			if ( result.status === "fulfilled" ) {
				switch ( index ) {
					case 0:
						data = result.value;
						break;

					case 1:
						seoTags = result.value;
						break;
				}
			}

			if ( result.status === "rejected" && result.reason?.message === "TOKEN_EXPIRED_FORCE_LOGOUT" )
				forceLogout = true;
		} );

		if ( forceLogout )
			return {
				redirect: {
					destination : `/logout?forceLogout=${ true }&prevLocation=${ defaultProps?.currentPath }`,
					permanent   : false
				}
			};

		if ( !data || !data.liveTabOrdering || !data.liveTabOrdering.length )
			return { props: { ...defaultProps } };

		const { gameCards, tournaments } = formatOrderedLiveTabsData ( data );

		const { response } = await getGameAndTournament ( { defaultProps, gameCards, tournaments } );

		if ( !response.length )
			return { props: { ...defaultProps } };

		if ( !defaultProps?.isLoggedIn )
			context.res.setHeader (
				"Cache-Control",
				"public, s-maxage=90, stale-while-revalidate=120"
			);

		return { props: { ...defaultProps, response, seoTags: seoTags?.seo_tags || [] } };

	} catch ( error ) {

		if ( error?.message === "TOKEN_EXPIRED_FORCE_LOGOUT" )
			return {
				redirect: {
					destination : `/logout?forceLogout=${ true }&prevLocation=${ defaultProps?.currentPath }`,
					permanent   : false
				}
			};

		return { props: { ...defaultProps, response: [], seoTags: [] } };
	}

} );

export { getServerSideProps };

export default Live;
